import React from 'react';
import { connect } from 'react-redux';
import R from 'ramda';
import MenuItem from './nav-menu-item';
import { checkIfUpdatesExist } from '../../../../utils/mass-rate-change-helpers';

const LeftNav = ({ changeRateType, changeRoute, updateType, rateType, updated, gettingData, ...updateCategories }) => {
  const checkIfIsMatched = (updateType1, rateType1, updateType2, rateType2) => R.and(R.equals(updateType2, updateType1), R.equals(rateType1, rateType2));
  const checkIfIsUpdated = (updateType1, rateType1) => R.any((pair) => checkIfIsMatched(updateType1, rateType1, R.prop('updateType', pair), R.prop('rateType', pair)))(updated);
  const equipSubMenusFn = parentName => R.map(rateTypeAsSubMenu => ({
    name: `     ${rateTypeAsSubMenu}`,
    onTouchTap: () => changeRateType(rateTypeAsSubMenu, parentName),
    isActive: checkIfIsMatched(parentName, rateTypeAsSubMenu, updateType, rateType),
    hasUnsavedChanges: checkIfUpdatesExist(rateTypeAsSubMenu)(updateCategories[parentName].products),
    isUpdated: checkIfIsUpdated(parentName, rateTypeAsSubMenu),
  }));

  const menuItems = [
    { name: 'RATES',
      onTouchTap: () => changeRoute('seasonRates'),
      gettingData,
      subMenus: equipSubMenusFn('seasonRates')(updateCategories.seasonRates.subMenus),
    },
    { name: 'SPECIAL OFFERS',
      onTouchTap: () => changeRoute('offers'),
      gettingData,
      subMenus: equipSubMenusFn('offers')(updateCategories.offers.subMenus),
    },
    { name: 'EXTRA',
      onTouchTap: () => changeRoute('extras'),
      gettingData,
      subMenus: equipSubMenusFn('extras')(updateCategories.extras.subMenus),
    },
  ];
  const renderMenuItem = (menuItemProps, key) => {
    return (
      <div style={{ marginBottom: menuItemProps.subMenus ? '30px' : '0px' }} key={key}>
        { menuItemProps.name !== '     free' ? <MenuItem {...menuItemProps} key={key} /> : <div></div> }
        { menuItemProps.subMenus && menuItemProps.name !== '     free' ? menuItemProps.subMenus.map(renderMenuItem) : <div></div> }
      </div>);
  };
  return (
    <div className="contracting-left-nav-widget" style={{ backgroundColor: '#383e4b', width: '20%', display: 'inline-block', height: '550px', padding: '39px 10px 40px 0px', float: 'left' }}>
      {
        menuItems.filter(menuItem => menuItem.subMenus.length).map(renderMenuItem)
      }
    </div>
  );
};
const mapStateToProps = ({ contracting }) => ({
  gettingData: contracting.massRateChange.get('gettingData'),
  updateType: contracting.massRateChange.get('updateType'),
  rateType: contracting.massRateChange.get('rateType'),
  updated: contracting.massRateChange.get('updated').toJS(),
  seasonRates: contracting.massRateChange.get('seasonRates').toJS(),
  offers: contracting.massRateChange.get('offers').toJS(),
  extras: contracting.massRateChange.get('extras').toJS(),
});

export default connect(mapStateToProps)(LeftNav);



// WEBPACK FOOTER //
// ./src/app/components/contracting/mass-rate-change/left-nav/left-nav.jsx